
const ColumnTypeList = ['text', 'list', 'date']
export type ColumnType = typeof ColumnTypeList[number];
export const DEFAULT_COLUMN_WIDTH = 140;

// Per-type minimums applied when a column has no explicit width set in the DB.
// Contact column shows an avatar + phone number side-by-side and needs more room.
const COLUMN_TYPE_DEFAULT_WIDTH: Record<string, number> = {
  'whatsapp-id-cell': 220,
};

export const getDefaultColumnWidth = (type?: string): number =>
  (type && COLUMN_TYPE_DEFAULT_WIDTH[type]) || DEFAULT_COLUMN_WIDTH;

export const resolveColumnWidth = (column?: { type?: string; width?: number }): number => {
  if (column?.width != null) return column.width;
  return getDefaultColumnWidth(column?.type);
};

export interface TaskColumn {
  _id?: string;
  owner?: string;
  boardId?: string;
  type: ColumnType;
  title?: string;
  width?: number;
  order?: number;
  version?: number;
  static?: boolean;
  selector?: string;
  outerCell?: boolean;
  defaultOptionId?: string;
  isVisible?: boolean;
  customData?:any;
  deleted?:boolean
}
